import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={title} data-id="element-54">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-55" />

      {/* Modal */}
      <div className="relative bg-[#FDF8F0] rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden border border-[#B8A068]/30" data-id="element-56">
        {/* Header */}
        <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-[#B8A068]/20 bg-white/50" data-id="element-57">
          <h2 className="font-playfair text-xl md:text-2xl font-bold text-[#3D2E1F]" data-id="element-58">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-[#3D2E1F]/10 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B8A068]" aria-label="Cerrar" data-id="element-59">
            <XIcon className="w-5 h-5 text-[#3D2E1F]" data-id="element-60" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 md:px-8 py-6 overflow-y-auto max-h-[calc(80vh-72px)] text-[#3D2E1F] text-base md:text-lg leading-relaxed space-y-4" data-id="element-61">
          {children}
        </div>
      </div>
    </div>;
}
export function FooterSection() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-[#3D2E1F] py-12 px-4 sm:px-6 lg:px-8 text-center" data-id="element-62">
        <div className="max-w-4xl mx-auto" data-id="element-63">
          <p className="text-[#FDF8F0] opacity-70 text-sm md:text-base mb-6" data-id="element-64">
            Este producto no sustituye el consejo médico profesional,
            diagnóstico o tratamiento. Siempre busque el consejo de su médico u
            otro proveedor de salud calificado con cualquier pregunta que pueda
            tener sobre una condición médica.
          </p>

          {/* Legal Links */}
          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-65">
            <button onClick={() => setActiveModal('privacy')} className="text-[#FDF8F0] opacity-70 hover:opacity-100 text-sm md:text-base underline underline-offset-4 decoration-[#B8A068]/50 hover:decoration-[#B8A068] transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B8A068] rounded" data-id="element-66">
              Política de Privacidad
            </button>
            <span className="text-[#FDF8F0] opacity-30" aria-hidden="true" data-id="element-67">
              |
            </span>
            <button onClick={() => setActiveModal('terms')} className="text-[#FDF8F0] opacity-70 hover:opacity-100 text-sm md:text-base underline underline-offset-4 decoration-[#B8A068]/50 hover:decoration-[#B8A068] transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B8A068] rounded" data-id="element-68">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-[#FDF8F0] opacity-50 text-sm" data-id="element-69">
            &copy; {new Date().getFullYear()} Articulaciones Felices. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-70">
        <p data-id="element-71">
          <strong data-id="element-72">Última actualización:</strong> Marzo 2026
        </p>
        <p data-id="element-73">
          En Articulaciones Felices, respetamos y protegemos la privacidad de
          nuestros usuarios. Esta política describe cómo recopilamos, usamos y
          protegemos su información personal.
        </p>
        <h3 className="font-playfair font-bold text-lg mt-4" data-id="element-74">
          Información que recopilamos
        </h3>
        <p data-id="element-75">
          Recopilamos únicamente la información necesaria para procesar su
          compra, incluyendo su nombre y dirección de correo electrónico. No
          recopilamos información médica ni datos sensibles.
        </p>
        <h3 className="font-playfair font-bold text-lg mt-4" data-id="element-76">
          Uso de la información
        </h3>
        <p data-id="element-77">
          Su información se utiliza exclusivamente para entregar el producto
          digital adquirido y enviar comunicaciones relacionadas con su compra.
          No vendemos, alquilamos ni compartimos su información personal con
          terceros.
        </p>
        <h3 className="font-playfair font-bold text-lg mt-4" data-id="element-78">Seguridad</h3>
        <p data-id="element-79">
          Implementamos medidas de seguridad estándar de la industria para
          proteger su información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>
        <h3 className="font-playfair font-bold text-lg mt-4" data-id="element-80">Cookies</h3>
        <p data-id="element-81">
          Nuestro sitio puede utilizar cookies para mejorar su experiencia de
          navegación. Puede configurar su navegador para rechazar cookies,
          aunque esto podría afectar algunas funcionalidades.
        </p>
        <h3 className="font-playfair font-bold text-lg mt-4" data-id="element-82">Sus derechos</h3>
        <p data-id="element-83">
          Usted tiene derecho a acceder, corregir o eliminar su información
          personal en cualquier momento. También puede solicitar que dejemos de
          enviarle comunicaciones.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-84">
        <p data-id="element-85">
          <strong data-id="element-86">Última actualización:</strong> Marzo 2026
        </p>
        <p data-id="element-87">
          Al adquirir y utilizar el producto "Despierta Sin Dolor: Tu Diario de
          5 Minutos para Articulaciones Felices", usted acepta los siguientes
          términos y condiciones.
        </p>
        <h3 className="font-playfair font-bold text-lg mt-4" data-id="element-88">
          Naturaleza del producto
        </h3>
        <p data-id="element-89">
          Este es un producto digital informativo en formato PDF. No constituye
          consejo médico, diagnóstico ni tratamiento. Siempre consulte con un
          profesional de salud calificado antes de iniciar cualquier programa de
          ejercicios o cambios en su rutina de salud.
        </p>
        <h3 className="font-playfair font-bold text-lg mt-4" data-id="element-90">
          Entrega del producto
        </h3>
        <p data-id="element-91">
          Tras completar la compra, recibirá acceso inmediato al producto
          digital a través de su correo electrónico. Es su responsabilidad
          proporcionar una dirección de correo válida.
        </p>
        <h3 className="font-playfair font-bold text-lg mt-4" data-id="element-92">
          Propiedad intelectual
        </h3>
        <p data-id="element-93">
          Todo el contenido del producto está protegido por derechos de autor.
          Queda prohibida la reproducción, distribución o reventa del material
          sin autorización expresa por escrito.
        </p>
        <h3 className="font-playfair font-bold text-lg mt-4" data-id="element-94">
          Limitación de responsabilidad
        </h3>
        <p data-id="element-95">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos. El uso del producto es bajo su propia
          responsabilidad. No nos hacemos responsables por lesiones o daños
          derivados del uso incorrecto del contenido.
        </p>
        <h3 className="font-playfair font-bold text-lg mt-4" data-id="element-96">
          Política de reembolso
        </h3>
        <p data-id="element-97">
          Debido a la naturaleza digital del producto, todas las ventas son
          finales. Si experimenta problemas técnicos con la descarga, estaremos
          encantados de ayudarle.
        </p>
      </LegalModal>
    </>;
}